package com.havn.app.core.security

actual val havnTurnstileSiteKey: String = "0x4AAAAAADfNhNmvturSWcT3"